<template>
  <div class="donation-options-info mt-4 d-flex flex-column">
    <span class="donation-options-info__title mb-2">Funding Options</span>
    <p class="donation-options-info__description">
      You can support the production of my book in 3 ways. Any contribution to
      help publish my book is greatly appreciated.
    </p>
  </div>
</template>

<script>
export default {
  name: 'DonationOptionsInfo'
};
</script>

<style lang="scss">
.donation-options-info {
  &__title {
    font-size: 24px;
    font-weight: 600;
  }

  &__description {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
